import { GetAuthToken } from '@domain/auth/AuthContext';
import { IUserFull, IEditableUserAttributes } from '@domain/user/types';

import { returnJsonOrThrow, put } from './shared';

export const updateUserProfile = async (
  attributes: Partial<IEditableUserAttributes>,
  getAuthToken: GetAuthToken,
  headers?: object,
): Promise<IUserFull> =>
  put('/me', getAuthToken, attributes, headers).then(async r => returnJsonOrThrow<IUserFull>(r));
